import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { FC, useRef } from 'react';
import VimeoPlayer from '@/components/shared/VimeoPlayer';
import { useVimeoViewportPlayback } from '@/hooks/useVimeoViewportPlayback';
import { StrapiImage, StrapiVideo } from '@/types/common';
import css from '../style.module.scss';
interface Props {
  preview?: StrapiImage | StrapiVideo;
  videoUrl?: string;
  videoThumbnailUrl?: string;
  alt?: string;
  shouldLoadVideo?: boolean;
}
const MediaInfoPreview: FC<Props> = t0 => {
  const $ = _c(13);
  const {
    preview,
    videoUrl,
    videoThumbnailUrl,
    alt,
    shouldLoadVideo
  } = t0;
  const previewRef = useRef(null);
  const previewAlt = preview && "alternativeText" in preview && preview.alternativeText || "";
  const vimeoPlaying = useVimeoViewportPlayback(previewRef);
  if (videoUrl) {
    const t1 = alt ?? previewAlt;
    let t2;
    if ($[0] !== t1 || $[1] !== videoThumbnailUrl || $[2] !== videoUrl || $[3] !== vimeoPlaying) {
      t2 = <div ref={previewRef} className={css.image}><VimeoPlayer url={videoUrl} thumbnailUrl={videoThumbnailUrl} thumbnailAlt={t1} playing={vimeoPlaying} /></div>;
      $[0] = t1;
      $[1] = videoThumbnailUrl;
      $[2] = videoUrl;
      $[3] = vimeoPlaying;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  let t1;
  if ($[5] !== preview) {
    t1 = preview && "mime" in preview && preview.mime.startsWith("video");
    $[5] = preview;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const isVideo = t1;
  let t2;
  if ($[7] !== alt || $[8] !== isVideo || $[9] !== preview?.url || $[10] !== previewAlt || $[11] !== shouldLoadVideo) {
    t2 = <div className={css.image}>{isVideo ? <video muted={true} loop={true} playsInline={true} preload="none" width={750} height={420}>{shouldLoadVideo ? <source src={preview?.url ?? ""} type="video/mp4" /> : null}</video> : <Image preload={true} width={750} height={420} quality={100} src={preview?.url ?? ""} alt={alt ?? previewAlt} />}</div>;
    $[7] = alt;
    $[8] = isVideo;
    $[9] = preview?.url;
    $[10] = previewAlt;
    $[11] = shouldLoadVideo;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
};
export default MediaInfoPreview;